/*
  Scrolling banner marquee play/pause — extracted from sections/scrolling-banner.liquid so it
  ships from a cacheable, deferred asset instead of inline script.

  The section id was baked into the element lookup; init() now takes the root element and runs
  for every `[data-section-type="scrolling-banner"]`, still guarded by data-marquee-init.
*/
(function () {
  function init(root) {
    if (!root || root.dataset.marqueeInit === '1') return;
    root.dataset.marqueeInit = '1';

    var btn = root.querySelector('.marquee-with-toggle .nav-toggle');
    var marquee = root.querySelector('.marquee');
    if (!btn || !marquee) return;

    function getTracks() { return marquee.querySelectorAll('.marquee-content'); }

    function setState(state) {
      var isPlaying = state === 'playing';
      btn.dataset.state = state;
      btn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      btn.setAttribute('aria-label', isPlaying ? 'Pause slideshow' : 'Play slideshow');

      getTracks().forEach(function (el) {
        if (isPlaying) el.style.removeProperty('animation-play-state');
        else el.style.animationPlayState = 'paused';
      });
    }

    var initial = btn.getAttribute('data-state');
    if (initial !== 'paused' && initial !== 'playing') initial = 'playing';
    setState(initial);

    // Click / keyboard toggle
    btn.addEventListener('click', function () {
      setState(btn.dataset.state === 'playing' ? 'paused' : 'playing');
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        btn.click();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="scrolling-banner"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  window.addEventListener('pageshow', initAll); // iOS bfcache
})();
